import { EGDSCard, EGDSCardContentSection } from '@egds/react-core/cards';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSLayoutPosition } from '@egds/react-core/layout-position';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { EGDSSticky } from '@egds/react-core/sticky';
import { inject } from 'mobx-react';
import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { NavigationBar } from '@shared-ui/retail-product-navigation-bar';
import { PropertyNavigationBar, PropertyNavigationBarSplitted } from '@shared-ui/lodging-property-details';
import { RefTarget, useRefContext } from '@shared-ui/ref-context';
import { ViewLarge, Viewport } from '@shared-ui/viewport-context';
import { useRefProvider } from 'src/common/stores/contexts/ref-provider';
// Components
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { IdentifierType } from 'src/common/__generated__/api';
import { StickyBookBar } from 'components/infosite/template-components/sticky-book-bar';
import ViewportListener from 'components/common/lazy/viewport-listener';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const NavigationBarWrapper = inject('currentHotel', 'multiItem')(({
  inputs,
  showReserveBtn,
  showPriceOnLoad = false,
  showNightlyPrice,
  showReserveBtnOnLoad
}) => {
  const [priceboxInView, setPriceboxInView] = React.useState(!showPriceOnLoad);
  const [reserveBtnInView, setReserveBtnInView] = React.useState(showReserveBtnOnLoad);
  const [singleOfferRef] = useRefProvider('singleOfferPrice');
  const {
    getTargets
  } = useRefContext();
  const {
    Offers: offersRef
  } = getTargets(['Offers']);
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  const singleOfferRefCurrent = singleOfferRef === null || singleOfferRef === void 0 ? void 0 : singleOfferRef.current;
  const offersRefCurrent = offersRef === null || offersRef === void 0 ? void 0 : offersRef.current;
  const viewportListener = new ViewportListener();
  const layoutPosition = {
    right: 'zero',
    top: 'zero',
    bottom: 'zero'
  };
  React.useEffect(() => {
    if (singleOfferRefCurrent) {
      viewportListener.subscribe('window', singleOfferRefCurrent, {
        didEnter: () => setPriceboxInView(true),
        didExit: () => setPriceboxInView(false)
      });
    }
  }, [singleOfferRefCurrent]);
  React.useEffect(() => {
    if (offersRefCurrent) {
      new IntersectionObserver(entries => entries.forEach(entry => setReserveBtnInView(!entry.isIntersecting)), {
        rootMargin: '0% 0% -50% 0%'
      }).observe(offersRefCurrent);
    }
  }, [offersRefCurrent]);
  const oldNavigationBar = React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(EGDSCard, {
    className: "custom-css-flat-border-top custom-css-flat-border-bottom"
  }, React.createElement(EGDSCardContentSection, {
    border: "bottom",
    padded: false,
    "data-stid": "uitk-card-content-section-navbar"
  }, React.createElement(PropertyNavigationBar, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSCard, {
    className: "custom-css-flat-border-top custom-css-flat-border-bottom"
  }, React.createElement(EGDSCardContentSection, {
    border: "bottom",
    padded: false,
    "data-stid": "uitk-card-content-section-navbar"
  }, React.createElement(PropertyNavigationBarSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))));
  const productInputs = Object.assign(Object.assign({}, inputs), {
    productIdentifier: {
      id: inputs.propertyId,
      type: IdentifierType.PROPERTY_ID,
      travelSearchCriteria: {
        property: {
          primary: {
            dateRange: inputs.dateRange,
            destination: {},
            rooms: []
          }
        }
      }
    }
  });
  const newNavigationBar = React.createElement(EGDSCard, {
    className: "custom-css-flat-border-top custom-css-flat-border-bottom"
  }, React.createElement(EGDSCardContentSection, {
    border: "bottom",
    padded: false,
    "data-stid": "uitk-card-content-section-navbar"
  }, React.createElement(NavigationBar, {
    inputs: productInputs,
    skipSsr: cSRPropertyDetailsQuery
  })));
  return React.createElement(EGDSSticky, {
    zIndex: 400
  }, React.createElement(RefTarget, {
    name: "navigation"
  }, React.createElement(React.Fragment, null, React.createElement(Experiment, {
    name: "Navigation_bar_no_harm_test"
  }, React.createElement(ExperimentControl, null, oldNavigationBar), React.createElement(ExperimentVariant, {
    bucket: 1
  }, newNavigationBar)), (showReserveBtn && !priceboxInView || !showNightlyPrice && reserveBtnInView) && React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: layoutPosition
  }, React.createElement(EGDSSpacing, null, React.createElement(EGDSLayoutFlex, {
    blockSize: 'full_size',
    justifyContent: "end",
    alignItems: "center"
  }, React.createElement(EGDSSpacing, {
    padding: {
      inlineend: 'three'
    }
  }, React.createElement(EGDSLayoutFlexItem, {
    grow: 0
  }, React.createElement("div", {
    "data-stid": "navbar-quick-reserve-button"
  }, React.createElement(StickyBookBar, null))))))))))));
});
export const SharedUiNavigationBarWrapper = withSharedUiPropertyDetails(NavigationBarWrapper);
SharedUiNavigationBarWrapper.displayName = 'SharedUiNavigationBarWrapper';